import Swiper, { Navigation, Pagination, A11y } from 'swiper';

export default () => {
	const gridResults = document.querySelector(
		'#results-slider .grid-results .swiper-wrapper'
	);
	if (gridResults) {
		const gridResultsAmount = gridResults.dataset.totalResults;
		// results slider
		const resultsSwiper = new Swiper('#results-slider .grid-results', {
			modules: [Navigation, Pagination, A11y],
			navigation: {
				nextEl: '#results-slider .swiper-button-next',
				prevEl: '#results-slider .swiper-button-prev',
			},
			pagination: {
				el: '#results-slider .swiper-pagination',
				clickable: true,
			},
			a11y: true,
			autoHeight: true,
			keyboardControl: true,
			grabCursor: true,
			watchOverflow: true,
			loop: true,
			breakpoints: {
				320: {
					slidesPerView: 1,
					slidesPerGroup: 1,
				},
				768: {
					slidesPerView: 2,
					spaceBetween: 40,
					slidesPerGroup: 2,
				},
				1200: {
					slidesPerView: 4,
					pagination: false,
					slidesPerGroup: 4,
					spaceBetween: 45,
					loop: gridResultsAmount > 4,
				},
				1440: {
					slidesPerView: 5,
					slidesPerGroup: 5,
					loop: gridResultsAmount > 5,
				},
			},
		});
	}
};
